import {ProgressSpinner as PrimeProgressSpinner} from "primereact/progressspinner";
import styled from "styled-components";

export const ProgressSpinnerContainer = styled(PrimeProgressSpinner)`
    width: 10%;
    height: 10%;
    position: absolute;
    top: 50%;
    left: 50%;
`;